import { ThemeProvider as NextThemesProvider } from "next-themes";
import type { ComponentProps } from "react";

/**
 * Thin `next-themes` wrapper. `attribute="class"` toggles the `.dark` class on
 * <html>, matching the `@custom-variant dark (&:is(.dark *))` in
 * `src/index.css` so the OKLCH token set follows the theme.
 */
export function ThemeProvider({
  children,
  ...props
}: ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
      {...props}
    >
      {children}
    </NextThemesProvider>
  );
}
